import { colors } from '@material-ui/core'
import { Overrides } from '@material-ui/core/styles/overrides'

import { greyPalette, greenPalette } from './colors'

export const masmovilSwitchOverride: Overrides = {
  MuiSwitch: {
    root: {
      // disabled mode
      cursor: 'not-allowed',
    },
    switchBase: {
      cursor: 'pointer',
    },

    // The top circle should has opaque color because track element behind
    colorSecondary: {
      '&.Mui-checked': {
        color: greenPalette[550],
        '&+ .MuiSwitch-track': {
          opacity: 0.3,
        },
      },

      '&:not(.Mui-checked) + .MuiSwitch-track': {
        background: greyPalette[550],
        opacity: 1,
      },

      '&.Mui-disabled.Mui-checked': {
        color: greenPalette[250],
        opacity: 1,
      },

      '&.Mui-disabled.Mui-checked + .MuiSwitch-track': {
        background: greenPalette[550],
        opacity: 0.12,
      },

      '&.Mui-disabled:not(.Mui-checked)': {
        color: colors.grey[100],
      },

      '&.Mui-disabled + .MuiSwitch-track': {
        background: greyPalette[300],
        opacity: 1,
      },
    },
  },
}

export const llamayaSwitchOverride: Overrides = {
  MuiSwitch: {
    root: {
      // disabled mode
      cursor: 'not-allowed',
    },
    switchBase: {
      cursor: 'pointer',
    },

    // The top circle should has opaque color because track element behind
    colorSecondary: {
      '&.Mui-checked': {
        color: greenPalette[500],
        '&+ .MuiSwitch-track': {
          opacity: 0.3,
        },
      },

      '&:not(.Mui-checked) + .MuiSwitch-track': {
        background: greyPalette[500],
        opacity: 1,
      },

      '&.Mui-disabled.Mui-checked': {
        color: greenPalette[300],
        opacity: 1,
      },

      '&.Mui-disabled.Mui-checked + .MuiSwitch-track': {
        background: greenPalette[500],
        opacity: 0.12,
      },

      '&.Mui-disabled:not(.Mui-checked)': {
        color: colors.grey[100],
      },

      '&.Mui-disabled + .MuiSwitch-track': {
        background: greyPalette[300],
        opacity: 1,
      },
    },
  },
}
